import { Component, Input } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { MerchantService } from '../../services/merchant/merchant.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-delete-product-modal',
  templateUrl: './delete-product-modal.component.html',
  styleUrls: ['./delete-product-modal.component.scss']
})
export class DeleteProductModalComponent {
  @Input() merchant: any;

  show = false;
  selectedFile: File | null = null;
  minViewCount: number = 20;

  constructor(private merchantService: MerchantService, private toastr: ToastrService) {}

  openModal() {
    this.show = true;
  }
  closeModal() {
    this.show = false;
  }
  onFileChange(event: any) {
    const file = event.target.files && event.target.files[0];
    this.selectedFile = file || null;
  }
  onSubmit() {
    if (!this.selectedFile) {
      this.toastr.warning('Vui lòng chọn file!');
      return;
    }
    const formData = new FormData();
    formData.append('merchantId', this.merchant?.merchantId || this.merchant?.id || '');
    formData.append('file', this.selectedFile);
    formData.append('minViewCount', this.minViewCount.toString());
    this.merchantService.deleteProductRequest(formData).subscribe({
      next: () => {
        this.toastr.success('Yêu cầu xóa sản phẩm đã được gửi thành công!');
        this.closeModal();
      },
      error: (err: HttpErrorResponse) => {
        this.toastr.error('Gửi yêu cầu thất bại: ' + (err.error?.message || err.message));
      }
    });
  }
}
